import { render } from "./PoliciesCreate.vue?vue&type=template&id=4b393c1e"
import script from "./PoliciesCreate.vue?vue&type=script&lang=js"
export * from "./PoliciesCreate.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__